import { render, staticRenderFns } from "./FormationsSvg.vue?vue&type=template&id=d0c958de&"
import script from "./FormationsSvg.vue?vue&type=script&lang=ts&"
export * from "./FormationsSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports